<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="hours-management" class="data-list-container">

    <div class="vx-row mb-4">
      <div class="vx-col flex">
        <div>
          <div class="tr-button blue-button" @click="UpdateData">Update</div>
        </div>
        <div class="ml-4 flex py-1">
          <vs-switch vs-type="success" @input="statusChange($event)" v-model="open"/>
          <span>{{ getStatus(open) | title }}</span>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
        <vx-card title="Delivery Hours">

          <vs-table ref="delivery_table"  :data="deliveryHours">
            <template slot="thead">
              <vs-th >Day</vs-th>
              <vs-th >Opening</vs-th>
              <vs-th >Closing</vs-th>
              <vs-th >
                <vs-switch vs-type="success" v-model="deliveryAllStatus" @input="toggleDeliveryAllSwitches"/>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.dayname }}</p>
                </vs-td>

                <vs-td>
                  <vs-input type="time" @input="onDateChange(1, indextr, 'opening', $event)" :value="deliveryHours[indextr].opening" class="pickatime picker__input picker__input--active" :name="'item-'.concat(tr.id)" v-validate="'required'" />
                </vs-td>

                <vs-td>
                  <vs-input type="time" @input="onDateChange(1, indextr, 'closing', $event)" :value="deliveryHours[indextr].closing" class="pickatime picker__input picker__input--active" :name="'item-'.concat(tr.id)" v-validate="'required'" />
                </vs-td>
                <vs-td>
                  <vs-switch vs-type="success" :value="deliveryHours[indextr].status" @input="onDateChange(1, indextr, 'status', $event)"/>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="vx-col">
        <vx-card title="Pickup Hours">
          <vs-table ref="delivery_table"  :data="pickupHours">
            <template slot="thead">
              <vs-th>Day</vs-th>
              <vs-th>Opening</vs-th>
              <vs-th>Closing</vs-th>
              <vs-th >
                <vs-switch vs-type="success" @input="togglePickupAllSwitches" v-model="pickupAllStatus"/>
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.dayname }}</p>
                </vs-td>

                <vs-td>
                  <vs-input type="time" @input="onDateChange(2, indextr, 'opening',  $event)" :value="pickupHours[indextr].opening" class="pickatime picker__input picker__input--active" :name="'item-'.concat(tr.id)" v-validate="'required'" />
                </vs-td>

                <vs-td>
                  <vs-input type="time" @input="onDateChange(2, indextr, 'closing', $event)" :value="pickupHours[indextr].closing" class="pickatime picker__input picker__input--active" :name="'item-'.concat(tr.id)" v-validate="'required'" />
                </vs-td>

                <vs-td>
                  <vs-switch vs-type="success" :value="pickupHours[indextr].status" @input="onDateChange(2, indextr, 'status', $event)"/>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import vSelect from 'vue-select'

export default {
  components: {
    DataViewSidebar,
    vSelect
  },
  data () {
    return {
      intervalId: null,
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      open: false,
      currentRestaurant: null,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      contentType: 'slider',
      restaurantId: -1,
      pickupData: [],
      savedpickupData: [],
      deliveryData: [],
      saveddeliveryData: [],
      weekday: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      deliveryAllStatus: true,
      pickupAllStatus: true
    }
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.contents.length
    },
    pickupHours () {
      return this.$store.state.api.pickupHours
    },
    deliveryHours () {
      return this.$store.state.api.deliveryHours
    }
  },
  watch: {
    '$store.state.api.pickupHours' (val) {
      this.pickupData = val
    },
    '$store.state.api.deliveryHours' (val) {
      this.deliveryData = val
    },
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.restaurantId = this.selectedRestaurant.id

        if (this.selectedRestaurant.closed) {
          this.open = 0
        } else {
          this.open = 1
        }
        this.getWeeklyHours()
      }
    },
    pickupData () {
      if (this.pickupData.length === 0) {
        let i = 0
        for (i = 1; i < 8; i++) {
          this.pickupData.push({
            day_id: i,
            opening: '10:00',
            closing: '22:00',
            dayname: this.weekday[i - 1],
            status: 1
          })
        }
      }
    },
    deliveryData () {
      if (this.deliveryData.length === 0) {
        let i = 0
        for (i = 1; i < 8; i++) {
          this.deliveryData.push({
            day_id: i,
            opening: '10:00',
            closing: '22:00',
            dayname: this.weekday[i - 1],
            status: 1
          })
        }
      }
    }
  },
  methods: {
    UpdateData () {

      this.$vs.loading()
      this.savedpickupData = []
      this.pickupHours.map((item) => {
        this.savedpickupData.push({
          dayId: item.day_id,
          opening: item.opening,
          closing: item.closing,
          status: item.status
        })
      })

      const pickUpObj = {
        hourType: 2,
        restaurant_id: this.restaurantId,
        hours: this.savedpickupData
      }

      this.saveddeliveryData = []
      this.deliveryHours.map((item) => {
        this.saveddeliveryData.push({
          dayId: item.day_id,
          opening: item.opening,
          closing: item.closing,
          status: item.status
        })
      })

      const deliveryObj = {
        hourType: 1,
        restaurant_id: this.restaurantId,
        hours: this.saveddeliveryData
      }

      this.$store.dispatch('api/saveWeeklyHours', pickUpObj).then(() => {
        this.getWeeklyHours()
        this.$vs.loading.close()
      }).catch(err => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

      this.$store.dispatch('api/saveWeeklyHours', deliveryObj).then(() => {
        this.openAlert('Status changed successfully')
        this.$vs.loading.close()
      }).catch(err => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    },
    togglePickupAllSwitches (newValue) {
      // Tüm anahtarları döngü ile güncelle
      for (let i = 0; i < this.pickupHours.length; i++) {
        this.onDateChange(2, i, 'status', newValue)
      }
    },
    toggleDeliveryAllSwitches (newValue) {
      // Tüm anahtarları döngü ile güncelle
      for (let i = 0; i < this.deliveryHours.length; i++) {
        this.onDateChange(1, i, 'status', newValue)
      }
    },
    onDateChange (type, index, openclose, $event) {
      if ($event.length < 6) {
        $event = `${$event}:00`
      }

      const payload = { index, val: $event, type: openclose }

      if (type === 1) {
        this.$store.dispatch('api/setDeliveryHour', payload)
      } else {
        this.$store.dispatch('api/setPickupHour', payload)
      }

    },
    getWeeklyHours () {
      const payload = {
        restaurant_id: this.restaurantId,
        hourType: 1
      }
      const payload2 = {
        restaurant_id: this.restaurantId,
        hourType: 2
      }

      this.$store.dispatch('api/getDeliveryHours', payload)
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

      this.$store.dispatch('api/getPickupHours', payload2)
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    statusChange (event) {
      const obj = {
        restaurant_id: this.restaurantId,
        type: (event) ? 'start' : 'stop'
      }

      this.$store.dispatch('api/setRestaurantStatus', obj).then(response => {
        if (response.status) {
          this.$store.commit('api/SET_SELECTED_RESTAURANT', response.data.data)
          this.openAlert('Status changed successfully')

        }
      }).catch(err => { console.error(err) })
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        title: 'Confirm',
        clickNotClose: true,
        acceptText: 'Ok',
        text
      })
    },
    getStatus (active) {
      if (active === 1) {
        return 'Open'
      } else {
        return 'Closed'
      }
    },

    getRestaurant () {
      const payload = {
        restaurantId: this.selectedRestaurant.id
      }
      this.$store.dispatch('api/getRestaurant', payload)
        .then((response) => {
          //this.$store.commit('api/SET_SELECTED_RESTAURANT', response.data.data)
          this.currentRestaurant = response.data.data
          if (this.currentRestaurant.closed) {
            this.open = 0
          } else {
            this.open = 1
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  mounted () {
    this.isMounted = true
    if (this.selectedRestaurant) {
      this.restaurantId = this.selectedRestaurant.id
      this.getRestaurant()
      this.getWeeklyHours()
    }
    this.intervalId = setInterval(this.getRestaurant, 10 * 1000)

  }
}
</script>

<style lang="scss">
  #hours-management {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        padding: .5rem;
        border-spacing: .5rem;
        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }

    .product-img {
      max-width: 200px;
    }

    .vs--single.vs--open .vs__selected{
      position: initial;
    }
    .vs-table-primary{
      width:100%;
    }
  }
.vx-row{
  gap:20px;
.vx-col{
  max-width:850px;
}
}
</style>
